import { __ } from "@wordpress/i18n";
import React, { useState } from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const Page = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [selectedFilter, setSelectedFilter] = useState("all");
    const filters = [
        { all: "All" },
        { basic: "Basic" },
        { wordpress: "WordPress Specific" },
        { "script-styles": "Script & Styles" },
        { "rss-feed": "RSS Feed Settings" },
    ];
    return (
        <>
            <div className="setting-unit">
                <div className="d-flex align-items-center justify-content-center">
                    <div className="filter-wrapper background-purple-10">
                        {filters && filters.length && 
                            filters.map((filter, index) => {
                                return (
                                <button
                                    key={index}
                                    className={`filter-btn pl-heading-2 ${
                                        selectedFilter === Object.keys(filter)[0]
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                        setSelectedFilter(Object.keys(filter)[0])
                                    }
                                >
                                    <span>{Object.values(filter)[0]}</span>
                                </button>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
            {
                (selectedFilter === "all" || selectedFilter === "basic") &&

                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Basic", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("General hardening security policies you can apply to your WooCommerce site.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable \"anyone can register\"", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_anyone_can_register"
                                            checked={settingData?.security?.recommendations?.disable_anyone_can_register} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable the built-in file editors", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_file_editors"
                                            checked={settingData?.security?.recommendations?.disable_file_editors} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Prevent code execution in the public 'Uploads' folder", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.prevent_code_execution_uploads_folder"
                                            checked={settingData?.security?.recommendations?.prevent_code_execution_uploads_folder} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Hide your WordPress version", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.hide_wordpress_version"
                                            checked={settingData?.security?.recommendations?.hide_wordpress_version} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Prevent login feedback", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.prevent_login_feedback"
                                            checked={settingData?.security?.recommendations?.prevent_login_feedback} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable user enumeration", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_directory_browsing"
                                            checked={settingData?.security?.recommendations?.disable_directory_browsing} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Unset X-Powered-By header", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.unset_x_powered_by_header"
                                            checked={settingData?.security?.recommendations?.unset_x_powered_by_header} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Block the username 'admin'", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.block_common_usernames"
                                            checked={settingData?.security?.recommendations?.block_common_usernames} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Block user registrations when login and display name are the same", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.change_display_name"
                                            checked={settingData?.security?.recommendations?.change_display_name} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Hide Admin Bar From Frontend", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.hide_front_admin_bar"
                                            checked={settingData?.security?.recommendations?.hide_front_admin_bar} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Hide Admin Bar From Backend", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.hide_back_admin_bar"
                                            checked={settingData?.security?.recommendations?.hide_back_admin_bar} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            {
                (selectedFilter === "all" || selectedFilter === "wordpress") &&
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("WordPress Specific", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Includes WordPress-specific security policies you can apply.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">

                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable WordPress Core Auto Updates", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_wp_core_auto_updates"
                                            checked={settingData?.security?.recommendations?.disable_wp_core_auto_updates} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Plugin Auto Updates", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_plugin_auto_updates"
                                            checked={settingData?.security?.recommendations?.disable_plugin_auto_updates} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Theme Auto Updates", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_theme_auto_updates"
                                            checked={settingData?.security?.recommendations?.disable_theme_auto_updates} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Remove RSD Link", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.remove_rsd_link"
                                            checked={settingData?.security?.recommendations?.remove_rsd_link} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Hide WordPress Version", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.hide_wordpress_version"
                                            checked={settingData?.security?.recommendations?.hide_wordpress_version} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Remove WLW Manifest Link", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.remove_wlw_manifest_link"
                                            checked={settingData?.security?.recommendations?.remove_wlw_manifest_link} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Remove Shortlink", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.remove_shortlink"
                                            checked={settingData?.security?.recommendations?.remove_shortlink} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Shortcode in WP Widgets", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.remove_shortlink"
                                            checked={settingData?.security?.recommendations?.remove_shortlink} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
            }
            {
                (selectedFilter === "all" || selectedFilter === "script-styles") &&
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Script & Styles", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Includes script and styles-related policies you can apply.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">

                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Hide CSS File Version", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.hide_css_file_version"
                                            checked={settingData?.security?.recommendations?.hide_css_file_version} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Hide JS File Version", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.hide_js_file_version"
                                            checked={settingData?.security?.recommendations?.hide_js_file_version} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Dashicons in Frontend", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_dashicons_in_frontend"
                                            checked={settingData?.security?.recommendations?.disable_dashicons_in_frontend} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Embeds", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_embeds"
                                            checked={settingData?.security?.recommendations?.disable_embeds} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
            }
            {
                (selectedFilter === "all" || selectedFilter === "rss-feed") &&
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("RSS Feed", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Includes policies you can apply to the RSS feed of your site.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">

                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable RSS Feed", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.disable_rss_feed"
                                            checked={settingData?.security?.recommendations?.disable_rss_feed} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Remove RSS Feed Links", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable RSS Feed", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.remove_rss_feed_links"
                                            checked={settingData?.security?.recommendations?.remove_rss_feed_links} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">                                    
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Remove RSS Feed Links", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Add Feature Image To RSS Feed", "ultimate-security")}</h6>
                                        </div>
                                    </div>                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.recommendations.add_feature_image_to_rss_feed"
                                            checked={settingData?.security?.recommendations?.add_feature_image_to_rss_feed} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
            }
            
        </>
    )
}
export default withForm(Page, 'security.recommendations');